import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class RouterModule extends VuexModule {
  public previousRouter: any = null;
  public searchParameters: any = null;

  @Mutation
  upPreviousRouter(previousRouter: any): void {
    this.previousRouter = previousRouter;
  }
  @Mutation
  upSearchParameters(searchParameters: any): void {
    this.searchParameters = !this.searchParameters || !searchParameters
      ? searchParameters
      : { ...this.searchParameters, ...searchParameters };
  }

  @Action({ rawError: true })
  setPreviousRouter(previousRouter: any) {
    this.context.commit("upPreviousRouter", previousRouter);
  }
  @Action({ rawError: true })
  clear() {
    this.context.commit("upPreviousRouter", null);
  }
  @Action({ rawError: true })
  setSearchParameters(searchParameters: any) {
    this.context.commit("upSearchParameters", searchParameters);
  }

  get getPreviousRouter(): any {
    return this.previousRouter;
  }

  get getSearchParameters(): any {
    return this.searchParameters;
  }
}
